// @mui
import { Box, BoxProps, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
//
import Image from "./Image";
import { LoadingButton } from "@mui/lab";

// ----------------------------------------------------------------------

const RootStyle = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  textAlign: "center",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(2, 2),
}));

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  title: string;
  size?: number;
  img?: string | null;
  description?: string;
  actionText?: string;
  actionLoading?: boolean;
  onActionClick?: () => void;
}

export default function EmptyContent({
  title,
  description,
  img,
  actionText,
  actionLoading,
  onActionClick,
  size,
  width,
  height,
  ...other
}: Props) {
  return (
    <RootStyle {...other}>
      {img !== null && (
        <Image
          disabledEffect
          visibleByDefault
          alt="empty content"
          src={img || "/assets/illustrations/illustration_empty_content.png"}
          sx={{
            height: size || height || 240,
            mb: 3,
            width: size || width,
            borderRadius: "8px",
          }}
        />
      )}

      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {description}
        </Typography>
      )}

      {actionText && (
        <LoadingButton
          sx={{ my: 3 }}
          variant="contained"
          onClick={onActionClick}
          loading={actionLoading}
        >
          {actionText}
        </LoadingButton>
      )}
    </RootStyle>
  );
}
